<template>
    <div :class="getClass">
        <img :src="file_url" />
    </div>
</template>

<script>
export default {
    props: ['file_url'],

    computed: {
        getClass() {
            if (this.$q.platform.is.mobile) return 'image-player-mobile'
            else return 'image-player-desktop'
        }
    }
}
</script>

<style lang="stylus" scoped>
.image-player-desktop
    & img
        width 100%
        height auto

.image-player-mobile
    & img
        width 100%
        max-height 565px
</style>
